module.exports = __webpack_public_path__ + "img/modal-bg.9793587e.png";